export default __webpack_public_path__ + "static/media/Arch_AWS-Auto-Scaling_64.14c61bcc.svg";